import { Component, inject } from '@angular/core';

import { trackByValue } from '@core/common-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogRef,
  HeadingComponent,
  IconComponent,
  IconName,
} from '@core/user-interface-legacy';

type IllustrationDialogResult = string | number | boolean;

interface IllustrationDialogButton {
  text: string;
  variant: 'primary' | 'default' | 'outline' | string;
  result?: IllustrationDialogResult;
  icon?: IconName;
  handler?: (dialogRef: DialogRef<IllustrationDialogComponent>) => void;
}

export interface IllustrationDialogData {
  imageSrc: string;
  imageHeight?: string;
  message: string;
  description?: string;
  descriptionVariant?: string;
  buttons: IllustrationDialogButton[];
}

@Component({
  selector: 'rt-illustration-dialog',
  templateUrl: './illustration-dialog.component.html',
  styleUrls: ['./illustration-dialog.component.less'],
  imports: [ButtonComponent, DialogBodyComponent, HeadingComponent, IconComponent],
})
export class IllustrationDialogComponent implements DialogComponentI<
  IllustrationDialogData,
  IllustrationDialogResult
> {
  private readonly dialogRef = inject<DialogRef<IllustrationDialogComponent>>(DialogRef);

  public imageSrc: string;
  public imageHeight: string;
  public message: string;
  public description?: string;
  public descriptionVariant: string;
  public buttons: IllustrationDialogButton[];
  public trackByValue = trackByValue;

  public setDialogData(data: IllustrationDialogData): void {
    this.imageSrc = data.imageSrc;
    this.message = data.message;
    this.buttons = data.buttons;
    this.description = data.description;
    this.descriptionVariant = data.descriptionVariant ?? 'subheading';
    this.imageHeight = data.imageHeight ?? '220px';
  }

  public close(button: IllustrationDialogButton): void {
    button.handler ? button.handler(this.dialogRef) : this.dialogRef.close(button.result);
  }
}
